// extracted by mini-css-extract-plugin
export default {"panel":"index_panel__AWhli","button":"index_button__UNTJM"};